import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GetCourtBookingList } from "../../../utilities/api/courtBooking";
import { BookedCourtListType } from "../../../utilities/types";
import { messages } from "../../../utilities/Messages";

type ErrorMessageType = {
  message: string;
}

const initialState = {
  currentPage: 0,
  rowsPerPage: 0,
  totalPage: 0,
  totalRows: 0,
  AllBookedCourtsData: [] as BookedCourtListType[],
  errorMessage: {} as ErrorMessageType,
  courtColumns: [
    {
      Header: "Coustomer Name",
      accessor: "fullName",
    },
    {
      Header: "Contact Number",
      accessor: "phone",
    },
    {
      Header: "Booking Type",
      accessor: "bookingType",
    },
    {
      Header: "Company Name",
      accessor: "companyName",
    },
    {
      Header: "Booking Date",
      accessor: "bookingDate",
    },
    {
      Header: "Start Date",
      accessor: "startDate",
    },
    {
      Header: "End Date",
      accessor: "endDate",
    },
    {
      Header: "Booking Status",
      accessor: "status",
    },
    {
      Header: "Payment Status",
      accessor: "paymentStatus",
    },
  ],
};

export const AllBookedCourtsList = createAsyncThunk(
  "BookedCourtsList/AllBookedCourtsList",
  (data: any) => GetCourtBookingList(data)
);

const CourtBookingListSlice = createSlice({
  name: "BookedCourtsList",
  initialState,
  reducers: {
    setCourtColumn: (state: any, action: any) => {
      state.courtColumns = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(
        AllBookedCourtsList.fulfilled,
        (state, action: PayloadAction<any>) => {
          if (action.payload.statusCode === 200) {
            let data = action.payload.data;
            state.rowsPerPage = data.limit;
            state.currentPage = data.page;
            state.totalPage = data.totalPages;
            state.totalRows = data.totalRows;

            state.AllBookedCourtsData = data.rows.map(
              (item: any, index: number) => ({
                srNo: index + 1,
                id: item.id,
                fullName: item.user.firstName + " " + item.user.lastName,
                phone: item.user.phone,
                bookingType: item.bookingType,
                companyName: item.companyName ? item.companyName : "-",
                bookingDate: item.createdAt,
                status: item.status,
                courtName: item.courtName,
                sportName: item.sportName,
                totalAmount: Math.round(item.totalAmount),
                paymentMode: item.paymentMode,
                paymentMethod: item.paymentMethod ? item.paymentMethod : "-",
                paymentStatus: item.paymentStatus,
                facilityName: item.facilityName,
                startDate: item.startDate,
                endDate: item.endDate,
                hash: item?.hash,
              })
            );
          }
        }
      )
 .addCase(AllBookedCourtsList.rejected, (state, action) => {
            state.errorMessage = { message: messages.error.internal_server_error };
        });
  },
});

export default CourtBookingListSlice.reducer;
export const { setCourtColumn } = CourtBookingListSlice.actions;
